import { render, staticRenderFns } from "./Book-Video-Lesson.vue?vue&type=template&id=2e7c8dd0&scoped=true"
import script from "./Book-Video-Lesson.vue?vue&type=script&lang=js"
export * from "./Book-Video-Lesson.vue?vue&type=script&lang=js"
import style0 from "./Book-Video-Lesson.vue?vue&type=style&index=0&id=2e7c8dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c8dd0",
  null
  
)

export default component.exports